import React from 'react';
import { v4 as uuid } from 'uuid';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import schema from './schema';
import Body from './Body';

const Edit = (props) => {
  const { data, block, selected, onChangeBlock } = props;
  if (!__SERVER__) {
    if (!props.data?.slides || props.data?.slides?.length === 0) {
      props.onChangeBlock(props.block, {
        ...props.data,
        slides: [{ '@id': uuid() }],
      });
    }
  }
  if (__SERVER__) return null;
  const blockSchema = schema(props.intl);
  return (
    <>
      <Body {...data} isEditMode={true} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={blockSchema}
          title={blockSchema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
